import { ReactNode } from 'react';
import { Header, Footer } from '@/components';

export const LandingLayout = (props: { children: ReactNode }) => {
  return (
    <div className="">
      <Header isGlobalHeader isForSearchApplication />
      <div className="flex h-full min-h-[calc(100svh_-_(30px_+_118px))] flex-col items-center bg-white">
        {props.children}
      </div>
      <Footer isFullFooter />
    </div>
  );
};
